import React, { useState, useMemo, useEffect, Suspense, useContext } from 'react';
// import Swal from 'sweetalert2';
import moment from 'moment';
// MUI
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import { toast } from 'react-toastify';
import useStore from '../../states/store';
import { DashboardProvider } from '../Dashboard/useDashboard';
import TabPanel from '../../components/TabPanel';
import BorderSection from '../../components/BorderSectionv2';
// Components
import DonutApexChart from '../../components/DonutApexChart';
import Filter from './components/Filter';
import FieldReportTable from './components/FieldReportTable';
import ChartReportTable from './components/ChartReportTable';
import FieldDetailsModal from './components/FieldDetailsModal';
// API
import {
  getFieldEngagmentList,
  getFieldEngagmentMoe,
  getFieldEngagmentDetails,
} from '../../api/fieldEngagementApi';
// Context
import useFieldEngagementContext from './context/useFieldEngagementContext';
import AppConst from '../../components/AppLayout/const';

export default function FieldEngagement() {
  const auth = useStore((state) => state.auth);

  const defaultFilter = {
    manager_id: [{ label: 'ALL', value: null }],
    rep_id: [{ label: 'ALL', value: null }],
    month_year: moment().format('YYYY-MM'),
  };
  const { onSetTitle } = useContext(AppConst.AppContext);
  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [clearFilter, setClearFilter] = useState(0);
  const [fieldData, setFieldData] = useState({ loading: true, table: [] });
  const [chartTableData, setChartTableData] = useState({ loading: true, table: [] });
  const [chartData, setChartData] = useState({ loading: true, chart: [] });
  const [fieldDetailsData, setFieldDetailsData] = useState({ toggle: false, details: [] });

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  onSetTitle('Field Engagement Dashboard');

  const apiRequestParams = (requestType = null) => {
    const request = {
      department: ['CREDIT & COLLECTION'],
      team: [],
      head_id: [],
      manager_id:
        filterForm?.manager_id[0]?.value !== null
          ? filterForm?.manager_id?.map((row) => row.value)
          : [],
      rep_id:
        filterForm?.rep_id[0]?.value !== null ? filterForm?.rep_id?.map((row) => row.value) : [],
      date_from: moment(filterForm?.month_year).startOf('month').format('YYYY-MM-DD'),
      date_to: moment(filterForm?.month_year).endOf('month').format('YYYY-MM-DD'),
      type: requestType,
    };

    return request;
  };

  const handleFieldReport = async () => {
    try {
      setFieldData({ ...fieldData, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = apiRequestParams();
      const response = await getFieldEngagmentList(request);
      const { code, data } = response.data;

      if (code === '200') {
        setFieldData({ ...fieldData, loading: false, table: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleFieldReportMoe = async () => {
    try {
      setChartTableData({ ...chartTableData, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = apiRequestParams('list');

      const response = await getFieldEngagmentMoe(request);
      const { code, data } = response.data;

      if (code === '200') {
        setChartTableData({ ...chartTableData, loading: false, table: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleFieldReportChartMoe = async () => {
    try {
      setChartData({ ...chartData, loading: true });
      toast.loading('Processing request please kindly wait...');
      const request = apiRequestParams('chart');

      const response = await getFieldEngagmentMoe(request);
      const { code, data } = response.data;

      if (code === '200') {
        const items = {
          toggle: true,
          label: data?.label,
          value: data?.value,
          percentage: data?.percentage,
          total_percentage: data?.total,
        };
        setChartData({ ...chartData, loading: false, chart: items });
      }
      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleGenerateFilter = () => {
    handleFieldReport();
    handleFieldReportMoe();
    handleFieldReportChartMoe();
  };

  const handleClearFilter = () => {
    setFilterForm(defaultFilter);
    const rand = moment().format('msS');
    setClearFilter(rand);
  };

  const handleFieldDetailsData = async (row) => {
    toast.loading('Processing request please kindly wait...');
    const request = {
      user_id: row?.user_id,
      is_total: row?.user_type === 'manager_total' ? true : false,
      month: parseInt(moment(filterForm?.month_year).format('MM')),
      year: parseInt(moment(filterForm?.month_year).format('YYYY')),
    };
    const response = await getFieldEngagmentDetails(request);
    const { code, data } = response.data;

    if (code === '200') {
      setFieldDetailsData({ ...fieldDetailsData, toggle: true, details: data });
    }
    toast.dismiss();
  };
  useEffect(() => {
    handleGenerateFilter();
  }, [clearFilter]);
  return (
    <DashboardProvider>
      <useFieldEngagementContext.Provider
        value={useMemo(
          () => ({
            // GET
            activeTab,
            auth,
            filterForm,
            clearFilter,
            fieldData,
            chartTableData,
            chartData,
            fieldDetailsData,
            // SET
            setFilterForm,
            setClearFilter,
            setFieldData,
            setChartTableData,
            setChartData,
            setFieldDetailsData,
            // METHOD
            handleGenerateFilter,
            handleClearFilter,
            handleChangeActiveTab,
            handleFieldDetailsData,
          }),
          [filterForm, fieldData, chartTableData, chartData, fieldDetailsData],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>
        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab
                      label='Field Engagement'
                      id='field-engagement'
                      aria-controls='field-engagement'
                      name='field-engagement'
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={activeTab}>
                  {activeTab === 0 ? (
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FieldReportTable loading={fieldData?.loading} data={fieldData?.table} />
                      </Grid>

                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box pb={2}>
                          <ChartReportTable
                            loading={chartTableData?.loading}
                            data={chartTableData?.table}
                          />
                        </Box>
                        {!chartData?.loading ? (
                          <Suspense fallback={<LinearProgress />}>
                            <BorderSection title='MOE Breakdown Chart'>
                              <Box sx={{ paddingLeft: '110px' }}>
                                <DonutApexChart name='targetaccount' data={chartData?.chart} />
                              </Box>
                            </BorderSection>
                          </Suspense>
                        ) : (
                          <LinearProgress />
                        )}
                      </Grid>
                    </Grid>
                  ) : (
                    ''
                  )}
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {fieldDetailsData?.toggle ? <FieldDetailsModal /> : ''}
      </useFieldEngagementContext.Provider>
    </DashboardProvider>
  );
}
